// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"349":"01600768","453":"1ebc3e3a","640":"b6f688bc"}[chunkId] + ".chunk.js";
};